import React from "react"
import PropTypes from "prop-types"
import {get} from "lodash"

import {Label} from "@irati-web/insights/src/ui/FormItem"
import {Input} from "@irati/ui/src/FormItem"
import Validation from "@irati/utils/validation"
import id from "@irati/utils/id"
import {injectIntl, FormattedMessage} from "@irati/utils/lang"


const PROPERTY = "subject"

export const schema = (formatMessage) => Validation.string(formatMessage({id: "insights.validation.required"}))


const Subject = ({intl, name, schedule, onChange, label, className, formatMessage, ...props}) => {
  const intlLabel = <Label bold flush> <FormattedMessage id={label} /> </Label>

  return (
    <Input
      {...props}
      className={`${className} clearfix`}
      id={id(name, props)}
      name={name}
      value={get(schedule, name)}
      onChange={(value) => onChange(schedule, name, value)}
      label={intlLabel} />
  )
}

Subject.propTypes = {
  schedule: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired,
  label: PropTypes.string,
  hint: PropTypes.string,
  name: PropTypes.string,
  className: PropTypes.string,
  formatMessage: PropTypes.func.isRequired
}

Subject.defaultProps = {
  label: `insights.fields.schedule.${PROPERTY}.label`,
  hint: null,
  name: PROPERTY,
  className: null
}

export default injectIntl(Subject)
